export const initialPaging = {
  next: true,
  previous: false,
  totalPages: 0,
  pageIndex: 0,
};
